import { useRouter } from 'next/router';


const useSearchState = (paramKey, { resetDependentKeys = [], resetPageNumber = false, pageNumberParamKey = 'page' } = {}) => {
  const router = useRouter();

  const searchParams = new URLSearchParams(router.query);
  const value = searchParams.get(paramKey) || null;

  return [value, newValue => {
    // window should be fine here since it's called in the update callback
    const newSearchParams = new URLSearchParams(window.location.search);

    if (!newValue) {
      newSearchParams.delete(paramKey);
    } else {
      newSearchParams.set(paramKey, newValue);
    }

    if (resetPageNumber) {
      newSearchParams.delete(pageNumberParamKey);
    }

    resetDependentKeys.forEach(key => {
      newSearchParams.delete(key);
    })

    const query = {};
    const shallow = true;

    newSearchParams.forEach((value, key) => {
      query[key] = value;
    });

    router.push({ query, shallow });
  }];
};

export default useSearchState;
